"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styles_1 = require("../styles");
const Discard = ({ onDiscard, isHardChoice, size, i18n }) => {
    if (!isHardChoice)
        return null;
    const handleClick = () => onDiscard();
    return ((0, jsx_runtime_1.jsx)(styles_1.ButtonWrapper, { children: (0, jsx_runtime_1.jsx)(styles_1.DiscardButton, { isAsync: true, variant: "tertiary", size: size, onClick: handleClick, children: i18n('cart_widget.expired.cta.2') }) }));
};
exports.default = Discard;
